<div [ngStyle]="{'textAlign':textAlign}">
<span >{{showItems()}}</span>
</div>
